import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let blank = { component: { render (c) { return c('router-view') } } }

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/katalog',
            name: 'Katalog',
            component: () => import('@/views/Katalog')
        },
        {
            // path: '/katalog/detail',
            path: '/katalog/:id',
            name: 'Detail Katalog',
            component: () => import('@/views/KatalogDetail')
        },
        {
            path: '/katalog',
            name: 'Katalog',
            component: () => import('@/views/Katalog')
        }
    ]
}

export default new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
})
